import { Token } from "../store/global/TokenEnum";
import { GlobalStore } from "../store/global/GlobalStore";

export const useGetTokenMetadataBySymbol = () => {
  const tokenMetadata = GlobalStore.useState(s => s.tokens);
  return (symbol: Token) => {
    if (tokenMetadata == null) return undefined;
    return tokenMetadata[symbol];
  };
};
